export default __webpack_public_path__ + "static/media/download_pdf.69b020e8.png";